import React, { useMemo } from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import CarCardAdditionalDetails from 'components/atoms/CarCardAdditionalDetails'
import CarCardAdditionalDetailsItem from 'components/atoms/CarCardAdditionalDetailsItem'

import { getAssignmentState, getAssignmentStatusColor } from './assignmentLib'

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function AssignmentCarAdditionalDetails({
  vertical,
  partners = [],
  car,
  sessionState,
}) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')

  const assignmentState = useMemo(() => getAssignmentState(car), [car])

  const partnerName = useMemo(
    () =>
      car?.assignedPartnerId &&
      partners?.find((partner) => partner.partnerId === car.assignedPartnerId)
        ?.name,
    [car, partners]
  )

  const finalNetPrice = car.finalPrice
  const originalGrossPrice =
    Math.round(car.sixtPrice * (1 + car.feePercentage / 100) * 100) / 100
  const finalFee = car.assignmentFee
  const finalGrossPrice = finalFee + finalNetPrice

  return (
    <CarCardAdditionalDetails vertical={vertical}>
      <CarCardAdditionalDetailsItem
        vertical={vertical}
        title={t('assignment.additionalTitles.status')}
        value={t(`assignment.status.${sessionState}.${assignmentState}`)}
        valueProps={{
          color: getAssignmentStatusColor(assignmentState),
        }}
      />
      {!vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('assignment.additionalTitles.partner')}
          value={partnerName || '-'}
        />
      )}

      {['nr', 'missing', 'team ko'].includes(assignmentState) ? (
        <>
          {vertical && <Box p={1} />}
          <CarCardAdditionalDetailsItem
            vertical={vertical}
            title={t('assignment.additionalTitles.suggestedPrice')}
            value={
              (car.sixtPrice &&
                `€ ${numberFormatter.format(car.sixtPrice + car.fee)}`) ||
              '-'
            }
          />
          {vertical && <Box p={1} />}
          <CarCardAdditionalDetailsItem
            vertical={vertical}
            title={t('assignment.additionalTitles.accepted')}
            value={`${car.acceptedChoiceTotal || 0} ${t(
              'assignment.additionalValues.partner'
            )}`}
          />
          {vertical && <Box p={1} />}
          <CarCardAdditionalDetailsItem
            vertical={vertical}
            title={t('assignment.additionalTitles.acceptedWithReprice')}
            value={`${car.acceptedWithRepriceChoiceTotal || 0} ${t(
              'assignment.additionalValues.partner'
            )}`}
          />
          {vertical && <Box p={1} />}
        </>
      ) : (
        <>
          {vertical && <Box p={1} />}
          <CarCardAdditionalDetailsItem
            vertical={vertical}
            title={t('assignment.additionalTitles.finalPrice')}
            value={
              (finalGrossPrice &&
                `€ ${numberFormatter.format(finalGrossPrice)}`) ||
              '-'
            }
            strikeValue={
              finalGrossPrice !== originalGrossPrice &&
              `€ ${numberFormatter.format(originalGrossPrice)}`
            }
          />
        </>
      )}
    </CarCardAdditionalDetails>
  )
}

AssignmentCarAdditionalDetails.propTypes = {
  vertical: T.bool,
  partners: T.array,
  car: T.object.isRequired,
  sessionState: T.string.isRequired,
}
